import {
  List, Button, Grid, Dropdown, Segment, Container, Message
} from 'semantic-ui-react'
import './style.less'
import { useEffect, useState } from 'react'
import { Props, UserRelator } from './types'
import useStoreAtribuir from './store'
import { useStore } from '../../stores/useStoreProfile'
import { useHistory } from 'react-router-dom'

const FormAtribuir = (props: Props) => {
  const { itemTrabalho } = props
  const { store, success, userDepartamento, api } = useStoreAtribuir()
  const [init, setInit] = useState(true)
  const { store: profile, dominios, api: apiApp } = useStore()
  const { updatePermissions } = apiApp
  const history = useHistory()

  const areasRelatoras: number[] = profile.permissions.add_relator.filter(
    (e: any) => e.area_relatora
  ).map(
    (e: any) => +e.area_relatora
  )

  useEffect(() => {
    if (init) {
      setInit(false)
      const relatoras = areasRelatoras.filter(e => itemTrabalho.areas_relatoras?.find(a => a.id === e))
      itemTrabalho.id && api.list(itemTrabalho.id, relatoras)
      api.listUserDepartamento(relatoras)
    }
  }, [api, areasRelatoras, init, itemTrabalho, profile.permissions.add_relator])

  const getNomeRelator = (e: UserRelator) => {
    const sigla = dominios.departamento.find(d => d.id === e.area_relatora)?.sigla
    return `${(e.nome || 'Sem Nome')} (${sigla})`
  }

  const filterUserDepartamento = userDepartamento.filter(e =>
    !store.find(s => (s.key === e.key))
  ).map((e: UserRelator) => ({
    key: e.key,
    value: e.key,
    text: getNomeRelator(e),
    icon: 'user'
  }))

  return <Container fluid className='form-atribuir'>
    {api.checkError('detail') && <Message
      icon='times circle outline'
      error
      header={api.checkError('detail')}
    />}
    {success && <Message
      icon='check circle outline'
      success
      header={success}
    />}
    <Grid className='list-atribuir'>
      <Grid.Row columns='equal'>
        <Grid.Column verticalAlign='middle'>
          <label>Atribuir</label>
        </Grid.Column>
        <Grid.Column textAlign='right'>
          <Dropdown
            name="atribuir-add-relator"
            text='Adicionar relator'
            search
            icon='plus'
            className='icon'
            floating
            labeled
            button
            options={filterUserDepartamento}
            onChange={(_, { value }) => {
              const user = userDepartamento.find(e => e.key === value)
              user && api.add(user)
            }}
            selectOnBlur={false}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <List divided verticalAlign='middle'>
            {store.map(e =>
              <List.Item key={e.key}>
                <List.Icon name='user' />
                <List.Content verticalAlign='middle'>
                  {getNomeRelator(e)}
                </List.Content>
                <List.Content floated='right'>
                  <Button name="btn-removerrelator" basic compact negative icon={'trash alternate'}
                    onClick={() => api.remove(e)}
                  />
                </List.Content>
              </List.Item>
            )}
          </List>
        </Grid.Column>
      </Grid.Row>
    </Grid>

    <Segment basic clearing>
      <Button floated='left' name="atribuir-cancelar" onClick={() => history.goBack()}>Cancelar/Fechar</Button>
      <Button
        name="atribuir-salvar"
        floated='right'
        onClick={async () => {
          if (itemTrabalho.id) {
            await api.save(itemTrabalho.id, itemTrabalho.descricao, areasRelatoras)
            await updatePermissions()
          }
        }}
        title='Salvar'
        disabled={api.checkLoading('save')}
      >Salvar</Button>
    </Segment>

  </Container>
}

export default FormAtribuir
